import {
  RequestAcceptLiveMatch,
  RequestEndLiveCompetition,
  RequestListLiveMatch,
  RequestLiveMatch,
  RequestStartLiveCompetition,
} from '../models/request/requestLiveMatch';
import {
  ResponseListLiveMatch,
  ResponseLiveCompetitions,
  ResponseLiveMatch,
} from '../models/response/responseLiveMatch';
import { baseApi } from './baseApi';

const liveMatchAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get list live match
    getListLiveMatch: builder.mutation<
      ResponseListLiveMatch,
      RequestListLiveMatch
    >({
      query: (params: RequestListLiveMatch) => ({
        url: '/v0/live-matches',
        method: 'GET',
        params,
      }),
    }),
    //post live match
    postLiveMatch: builder.mutation<ResponseLiveMatch, RequestLiveMatch>({
      query: (body: RequestLiveMatch) => ({
        url: '/v0/live-matches',
        method: 'POST',
        body,
      }),
    }),
    // get live match
    getLiveMatch: builder.mutation<ResponseLiveMatch, string>({
      query: (liveId: string) => ({
        url: `/v0/live-matches/live/${liveId}`,
        method: 'GET',
      }),
    }),
    // accept match
    acceptLiveMatch: builder.mutation<
      ResponseLiveMatch,
      RequestAcceptLiveMatch
    >({
      query: (data: RequestAcceptLiveMatch) => ({
        url: `/v0/live-matches/${data.id}/reply`,
        method: 'PUT',
        body: data,
      }),
    }),
    // start live competitions
    startLiveCompetitions: builder.mutation<
      ResponseLiveCompetitions,
      RequestStartLiveCompetition
    >({
      query: (body: RequestStartLiveCompetition) => ({
        url: `/v0/live-competitions`,
        method: 'POST',
        body,
      }),
    }),

    // get info live competitions
    getLiveCompetitions: builder.mutation<ResponseLiveCompetitions, string>({
      query: (liveId: string) => ({
        url: `/v0/live-competitions/live/${liveId}`,
        method: 'GET',
      }),
    }),
    // end live match
    endLiveMatch: builder.mutation<any, string>({
      query: (id: string) => ({
        url: `/v0/live-matches/${id}`,
        method: 'DELETE',
      }),
    }),
    // end live competitions
    endLiveCompetitions: builder.mutation<any, RequestEndLiveCompetition>({
      query: (data: RequestEndLiveCompetition) => ({
        url: `/v0/live-competitions/${data.id}`,
        method: 'DELETE',
        body: data,
      }),
    }),
  }),
});
export const {
  useGetListLiveMatchMutation,
  usePostLiveMatchMutation,
  useGetLiveMatchMutation,
  useAcceptLiveMatchMutation,
  useStartLiveCompetitionsMutation,
  useGetLiveCompetitionsMutation,
  useEndLiveCompetitionsMutation,
  useEndLiveMatchMutation,
} = liveMatchAPI;
